import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "store";

export const getQuery = (state: RootState) => state.query;

export const getQueryTerms = createSelector(
  getQuery,
  (query) => query.queryTerms
);

export const getQueryFlags = createSelector(getQuery, (query) => query.flags);
